import PropTypes from 'prop-types';
import TableRow from '@mui/material/TableRow';
import Checkbox from '@mui/material/Checkbox';
import TableCell from '@mui/material/TableCell';
import { useBoolean } from 'src/hooks/use-boolean';
import { usePopover } from 'src/components/custom-popover';
import { dateformation } from 'src/components/date-format-mdy';
import { formatCurrency } from '../../risk-register/feching';
// ----------------------------------------------------------------------
export default function OrderTableRow({
  row,
  selected,
  onEditRow,
  onSelectRow,
  onDeleteRow,
  serialNumber,
}) {
  const {
    account_chart,
    bank_information,
    invoice_date,
    notes,
    note,
    debit,
    credit,
    cumulative_credit,
    cumulative_debit,
    balance,
  } = row;
  const confirm = useBoolean();
  const popover = usePopover();
  return (
    <>
      <TableRow hover selected={selected}>
        <TableCell padding="checkbox">
          <Checkbox checked={selected} onClick={onSelectRow} />
        </TableCell>
        <TableCell sx={{ whiteSpace: 'nowrap' }}>{serialNumber}</TableCell>
        <TableCell sx={{ whiteSpace: 'nowrap' }}>{account_chart?.code}</TableCell>
        <TableCell sx={{ whiteSpace: 'nowrap' }}>{account_chart?.name}</TableCell>
        <TableCell sx={{ whiteSpace: 'nowrap' }}>{dateformation(invoice_date)}</TableCell>
        <TableCell sx={{ whiteSpace: 'nowrap' }}>{account_chart?.account_type?.name}</TableCell>
        <TableCell sx={{ whiteSpace: 'nowrap' }}>{bank_information?.bank_name}</TableCell>
        <TableCell sx={{ whiteSpace: 'nowrap' }}>
          {bank_information?.opening_balance
            ? formatCurrency(bank_information?.opening_balance)
            : ''}
        </TableCell>
        <TableCell sx={{ whiteSpace: 'nowrap' }}>{formatCurrency(credit || 0)}</TableCell>
        <TableCell sx={{ whiteSpace: 'nowrap' }}>{formatCurrency(debit || 0)}</TableCell>
        <TableCell sx={{ whiteSpace: 'nowrap' }}>{formatCurrency(cumulative_credit)}</TableCell>
        <TableCell sx={{ whiteSpace: 'nowrap' }}>{formatCurrency(cumulative_debit)}</TableCell>
        <TableCell sx={{ whiteSpace: 'nowrap' }}>
          {formatCurrency(parseFloat(balance).toFixed(3) || 0)}
        </TableCell>
        <TableCell sx={{ whiteSpace: 'nowrap' }}>{notes || note}</TableCell>
      </TableRow>
    </>
  );
}
OrderTableRow.propTypes = {
  onDeleteRow: PropTypes.func,
  onEditRow: PropTypes.func,
  onSelectRow: PropTypes.func,
  row: PropTypes.object,
  selected: PropTypes.bool,
};
